import { action, makeObservable, observable } from 'mobx';
import { Model } from '~/shared/service/service.base';

@Model()
export class MenuModel {
	@observable open = false;
	@observable anchorEl: HTMLElement | null = null;

	constructor() {
		makeObservable(this);
	}

	@action.bound toggleMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.open = !this.open;
		this.anchorEl = event.currentTarget;
	};

	@action.bound closeMenu = () => {
		this.open = false;
		this.anchorEl = null;
	};

	@action.bound openMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.open = true;
		this.anchorEl = event.currentTarget;
	};
}
